import AuthenticationService from './../../services/AuthenticationService'
import alerts from '@/alerts/alert'
import Store from '@/store'
import confirmations from './confirmations'

const contact = {
  namespaced: true,
  state: {
    datas: [],
    loading: false,
    label: 'Create',
    modal: false,
    form: {}
  },
  getters: {
    getDatas (state) {
      return state.datas
    }
  },
  mutations: {
    SET_DATAS (state, data) {
      state.datas = data
    },
    SET_LOADING (state, loading) {
      state.loading = loading
    },
    SET_FORM (state, data) {
      state.form = data
    },
    SET_LABEL (state, data) {
      state.label = data
    }
  },
  actions: {
    async all ({ commit }, loader) {
      commit('SET_LOADING', loader)
      return await AuthenticationService.get('contact').then(({ data }) => {
        commit('SET_DATAS', data.data)
        commit('SET_LOADING', false)
      })
    },
    confirmationSave () {
      confirmations.confirmationForm('contact/save')
    },
    async save ({ commit, state }) {
      Store.dispatch('loading/setLoading', true)
      try {
        if (state.label === 'Create') {
          return await AuthenticationService.post('contact/create', state.form).then(({ data }) => {
            Store.dispatch('loading/setLoading', false)
            state.datas.push(state.form)
            if (data.code === 200) {
              Store.dispatch('contact/all', false)
              state.modal = false
            }
            alerts.sweetalertToast(data.code === 200 ? 'success' : 'error', data.message)
          })
        } else if (state.label === 'Update') {
          return await AuthenticationService.post('contact/update/' + state.form.id, state.form).then(({ data }) => {
            Store.dispatch('loading/setLoading', false)
            if (data.code === 200) {
              Store.dispatch('contact/all', false)
              state.modal = false
            }
            alerts.sweetalertToast(data.code === 200 ? 'success' : 'error', data.message)
          })
        } else if (state.label === 'Delete') {
          return await AuthenticationService.delete('contact/delete/' + state.form.id).then(({ data }) => {
            Store.dispatch('loading/setLoading', false)
            if (data.code === 200) {
              const index = state.datas.findIndex(item => item.id === state.form.id)
              state.datas.splice(index, 1)
              Store.dispatch('contact/all', false)
            }
            alerts.sweetalertToast(data.code === 200 ? 'success' : 'error', data.message)
          })
        }
      } catch (error) {
        Store.dispatch('loading/setLoading', false)
        alerts.sweetalertToast('error', error.message)
      }
    },
    onAction ({ commit, state }, payload) {
      commit('SET_LABEL', payload[1])
      commit('SET_FORM', payload[0])
      if (payload[1] === 'Delete') {
        confirmations.confirmationDelete('contact/save')
      } else {
        state.modal = true
      }
    }
  }
}

export default contact
